import React from 'react';
import { Link } from 'react-router-dom';

const SidebarItem = ({
  item,
  currentUrlPath,
  setDropdownActive,
  dropdownActive,
}) => {
  const type = localStorage.getItem('type');
  const hasChildren = item.children && item.children.length > 0;

  const toggleDropdown = () => {
    setDropdownActive((prev) =>
      prev[item.title] ? {} : { [item.title]: true }
    );
  };

  if (hasChildren) {
    return (
      <div className="app-nav-group">
        {/* Parent clickable */}
        <div
          onClick={toggleDropdown}
          className={`app-nav-item app-nav-parent ${dropdownActive[item.title] ? 'is-expanded' : ''}`}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') toggleDropdown();
          }}
        >
          <div className="app-nav-item-content">
            <span className="app-nav-icon"><i className={`fa ${item.icon}`}></i></span>
            <span className="app-nav-text">{item.title}</span>
          </div>
          <i
            className={
              dropdownActive[item.title]
                ? 'fas fa-chevron-down fs-chevron-12'
                : 'fas fa-chevron-right pt-1 fs-chevron-12'
            }
          ></i>
        </div>

        {/* Children */}
        <div className={!dropdownActive[item.title] ? 'd-none' : 'app-nav-children'}>
          {item.children.map(
            (child, index) =>
              child.auth.some((level) => level === type) && (
                <Link
                  key={index}
                  to={child.link}
                  className={`app-nav-child ${currentUrlPath === child.link ? 'is-active' : ''}`}
                >
                  <span>{child.title}</span>
                </Link>
              )
          )}
        </div>
      </div>
    );
  } else {
    return (
      <Link
        to={item.link}
        onClick={() => setDropdownActive({})}
        className={`app-nav-item ${currentUrlPath === item.link ? 'is-active' : ''}`}
      >
        <span className="app-nav-icon"><i className={`fa ${item.icon}`}></i></span>
        <span className="app-nav-text">{item.title}</span>
      </Link>
    );
  }
};

export default SidebarItem;
